import { render, staticRenderFns } from "./assignee_title.vue?vue&type=template&id=d5c0ff0e&"
import script from "./assignee_title.vue?vue&type=script&lang=js&"
export * from "./assignee_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports